module.exports = __webpack_public_path__ + "img/just-eat-logo.e817aac5.svg";